export default "<app-engine view=\"editor\"></app-engine>\n"